import TokenView from '@/language/pt/views/TokenView';

export default {
  TokenView,
};
